<template>
    <div class="bg-white rounded shadow flex">
        <div class="p-28 flex-1">
            <h3 class="font-semibold text-heading-1">{{ title }}</h3>
            <p class="mt-14 text-primary-80 text-body">{{ description }}</p>

            <div class="flex items-center my-20">
                <h4 class="shrink-0 pr-12 text-body-sm tracking-wider font-semibold uppercase text-secondary">
                    {{ $t('settings.pricing_plan.card.sub_title') }}
                </h4>
                <div class="flex-1 border-t-2 border-primary-20"></div>
            </div>
            <ul class="mt-8 space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-12">
                <li v-for="item in listItems" class="flex items-start lg:col-span-1">
                    <div class="shrink-0">
                        <svg-icon class="max-w-16 max-h-16 text-secondary-80" type="check-circle"></svg-icon>
                    </div>
                    <p class="ml-8 text-body-sm text-primary-80">
                        {{ item }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="px-24 bg-primary-5 self-stretch flex flex-col items-center justify-center gap-12">
            <p class="text-body">{{ priceTitle }}</p>
            <p class="flex items-center">
                <span class="flex items-center tracking-tight">
                    <span class="text-heading-1"><currency class="font-semibold" /></span>
                    <span class="font-semibold text-big">{{ price }}</span>
                </span>

                <span class="text-primary-80 text-body">/{{ $t('settings.pricing_plan.card.month') }}</span>
            </p>

            <p class="leading-none">
                {{ frequency === 'yearly' ? $t('settings.pricing_plan.billed_annually') : $t('settings.pricing_plan.billed_monthly') }}
            </p>

            <div v-if="withButtons" class="flex flex-col items-center gap-8">
                <simple-button
                    auto-width
                    display="primary"
                    @click="$emit('edit')"
                >
                    {{ $t('settings.pricing_plan.card.license_change') }}
                </simple-button>

                <simple-button
                    display="neutral"
                    look="text"
                    @click="$emit('cancel')"
                >
                    {{ $t('settings.pricing_plan.card.license_stop') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import SimpleButton from './ui/SimpleButton';
import SvgIcon from './ui/SvgIcon';
import Currency from '../components/Currency';

export default {
    components: {
        SimpleButton,
        'svg-icon': SvgIcon,
        Currency,
    },
    props: {
        title: String,
        description: String,
        listItems: Array,
        priceTitle: String,
        price: [String, Number],
        frequency: String,
        withButtons: Boolean,
    },
};
</script>
